import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TrimDirective } from '../../directives/trim.directive';
import { MessageModule } from 'primeng/message';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-input-textarea',
  imports: [CommonModule, ReactiveFormsModule, TextareaModule, TrimDirective, MessageModule ],
  templateUrl: './input-textarea.component.html',
  styleUrl: './input-textarea.component.scss'
})
export class InputTextareaComponent {

  @Input() form!: FormGroup;
  @Input() field!: string;
  @Input() label!: string;
  @Input() placeholder!: string;
  @Input() groupName!: string;
  @Input() maxlength!: number;  
}
